import React from 'react';

import PropTypes from 'prop-types';

import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';

import PreCheckRow from './PreCheckRow';
import FeeTextPopup from '../FeeTextPopup';

const PreCheckDeliveryRow = (props) => {
    return (
        <PreCheckRow
            title={props.title}
            text={
                <>
                    {props.description.indexOf(':') !== -1 && (
                        <>
                            {props.description.split(':')[1]}
                            {props.comment && (
                                <DiskButton type="button" iconName="info-rounded" size="small" marginRight="-8px" marginTop="-4px" raised={false} />
                            )}
                        </>
                    )}
                    {props.description.indexOf(':') === -1 && (
                        <>
                            {props.description}
                            {props.comment && (
                                <DiskButton type="button" iconName="info-rounded" size="small" marginRight="-8px" marginTop="-4px" raised={false} />
                            )}
                        </>
                    )}
                </>
            }
            onClick={() => {
                if (props.comment) {
                    props.popupRef?.current?.open(
                        <FeeTextPopup
                            popupRef={props.popupRef}
                            countryToId={props.toCountryId}
                            text={props.comment}
                            isComment={true}
                            isShowTerms={true}
                            deliveryMethod={props.deliveryMethod}
                            closeHandler={props.closeHandlerForPopup}
                            onPopupClose={props.closeHandlerForPopup}
                        />,
                    );
                }
            }}
        />
    );
};
PreCheckDeliveryRow.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    toCountryId: PropTypes.number,
    comment: PropTypes.string,
    deliveryMethod: PropTypes.string,
    closeHandlerForPopup: PropTypes.func.isRequired,
    popupRef: PropTypes.shape({ current: PropTypes.object }).isRequired,
};
export default PreCheckDeliveryRow;
